import { lazy, Suspense, useState } from 'react';
import { CheckCircle2, Download } from 'lucide-react';
import { usePwaInstall } from '../hooks/usePwaInstall';
import { useT } from '../hooks/useT';

// Dialogen worden pas geladen als ze open gaan: scheelt JavaScript bij het starten.
const InstallGuideModal = lazy(() => import('./InstallGuideModal').then((m) => ({ default: m.InstallGuideModal })));

/** "Voeg toe aan beginscherm": native prompt waar mogelijk, anders stapsgewijze uitleg. */
export function InstallCard() {
  const { t } = useT();
  const { isInstalled, isIOS, install } = usePwaInstall();
  const [showGuide, setShowGuide] = useState(false);

  if (isInstalled) {
    return (
      <div className="flex items-center gap-2 text-sm text-slate-600 dark:text-slate-400">
        <CheckCircle2 size={18} aria-hidden /> <span className="whitespace-nowrap">{t('installedBadge')}</span>
      </div>
    );
  }

  const onInstall = async () => {
    if (!(await install())) setShowGuide(true);
  };

  return (
    <>
      <div className="flex items-center justify-between gap-3">
        <div className="min-w-0">
          <p className="font-semibold">{t('installTitle')}</p>
          <p className="text-sm text-slate-600 dark:text-slate-400">{t('installDesc')}</p>
        </div>
        <button
          onClick={onInstall}
          className="flex min-h-11 items-center gap-2 whitespace-nowrap rounded-2xl bg-slate-900 px-4 text-sm font-semibold text-slate-50 transition-all duration-150 active:scale-95 dark:bg-slate-100 dark:text-slate-900"
        >
          <Download size={18} aria-hidden /> {t('installBtn')}
        </button>
      </div>

      {showGuide && (
        <Suspense fallback={null}>
          <InstallGuideModal isIOS={isIOS} onClose={() => setShowGuide(false)} />
        </Suspense>
      )}
    </>
  );
}
